"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = translate;
exports.translateSingle = translateSingle;
require("core-js/modules/web.dom-collections.iterator.js");
var _methods = require("./methods");
/**
 * =======  Based on Assembless/react-littera =======
 *
 * Returns object with translated values based on locale.
 * @category CoreWrap
 * @param {ITranslations} translations
 * @param {string} locale
 * @param {string} defaultText
 * @example
 * // Example of using translations.
 *
 * const translations = {
 *    example: {
 *      en-US: "Example",
 *      de-DE: "Beispiel"
 *    },
 *    hello: (name: string) => ({
 *      en-US: `Hello ${name}`,
 *      de-DE: `Hallo ${name}`
 *    })
 *    slogans: [
 *      {
 *        en-US: "Welcome to the show",
 *        de-DE: "Willkommen in der Show"
 *      }
 *    ]
 * }
 *
 * const translated = translate(translations, "de-DE");
 *
 * translated.example // => "Beispiel"
 * translated.hello("Mike") // => "Hallo Mike"
 * translated.slogans[0] // => "Welcome to the show"
 * @returns {ITranslated}
 */
function translate(translations, locale) {
  let defaultText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (typeof locale !== 'string') throw new Error("Expected a string for locale, got: ".concat(typeof locale));
  if (typeof translations !== 'object' || Array.isArray(translations)) throw new Error("Expected an object for translations, got: ".concat(Array.isArray(translations) ? 'array' : typeof translations));
  let translated = {};

  /** @todo refactor to Object.keys(translations).map() */
  for (let i = 0; i < Object.keys(translations).length; i++) {
    const key = Object.keys(translations)[i];
    const value = translations[key];
    translated[key] = translateSingle(value, locale) || defaultText;
  }
  return translated;
}

/**
 * Returns translated string based on locale.
 * @param {ITranslation} translation
 * @param {string} locale
 * @example
 * // Example of utilizing a single translation.
 *
 * const translations = {
 *    example: {
 *      en-US: "Example",
 *      de-DE: "Beispiel"
 *    },
 *    hello: (name: string) => ({
 *      en-US: `Hello ${name}`,
 *      de-DE: `Hallo ${name}`
 *    }),
 *    slogans: [
 *      {
 *        en-US: "Welcome to the show",
 *        de-DE: "Willkommen in der Show"
 *      }
 *    ]
 * }
 *
 * const translatedExample = translateSingle(translations.example, "de-DE");
 * const translatedHello = translateSingle(translations.hello("Mike"), "de-DE");
 * const translatedArr = translateSingle(translations.slogans[], "de_DE");
 *
 * translatedExample // => "Beispiel"
 * translatedHello("Mike") // => "Hallo Mike"
 * translatedArr[0] // => "Welcome to the show"
 * @returns {ISingleTranslated}
 */
function translateSingle() {
  var _Object$keys;
  let translation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let locale = arguments.length > 1 ? arguments[1] : undefined;
  if ((0, _methods.isTransArrayFunction)(translation)) return translation.map(t => translateSingle(t, locale));
  const activeLocaleInTranslation = (_Object$keys = Object.keys(translation)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(key => key.indexOf(locale.slice(0, 2)) === 0);
  if ((0, _methods.isVariableFunction)(translation))
    // return ((...args) => translation(...args)[locale]);
    return function () {
      return translation(...arguments)[activeLocaleInTranslation];
    };

  // return translation[locale];
  return translation[activeLocaleInTranslation];
}